import { Button, Stack, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ArrayTranslation } from '@hotjar/translations';
import type { Currency } from '~/subscription-management/api/common/model/customer';
import { PriceReview } from '~/subscription-management/features/price-review/PriceReview';
import { usePrettifyPrice } from '~/subscription-management/utils/cost/prettify-price';
import { SUBSCRIPTIONS } from '../../../../constants/routes';
import { navigateTo } from '../../../../external-dependencies/webapp-utils';
import processChurnSuccessGraphic from '../../../../resources/images/processed-churn-success.svg';
import { Image, TextWithLineBreak } from '../ProcessOrderContainer.styles';

interface Props {
  emailAddress: string | undefined;
  subscriptionEndDate: string | undefined;
  currency: Currency;
  price: number;
}

const S = {
  StyledPriceReview: styled(PriceReview)`
    background-color: ${tokens.ALIAS_COLORS.bg_info};
  `,
};

export function ProcessOrderChurnSuccess({
  emailAddress,
  subscriptionEndDate,
  currency,
  price,
}: Props): JSX.Element {
  const { t } = useTranslation('checkout', { keyPrefix: 'process-order.churn-success' });

  const { prettifyPrice } = usePrettifyPrice(currency);

  return (
    <Stack spacing="x3" direction="column">
      <Image src={processChurnSuccessGraphic} alt="" />
      <TextWithLineBreak as="h1" textType="header4">
        {t('title')}
      </TextWithLineBreak>
      <div>
        <ArrayTranslation
          t={t}
          i18nKey="body"
          options={{ emailAddress, subscriptionEndDate }}
          mapperFunction={(paragraph: string) => (
            <TextWithLineBreak key={paragraph} as="p" textType="body2">
              {paragraph}
            </TextWithLineBreak>
          )}
        />
      </div>
      <div>
        <S.StyledPriceReview loading={false}>
          <PriceReview.Price
            title={t('next-charge')}
            price={prettifyPrice(price)}
            loading={false}
          />
        </S.StyledPriceReview>
      </div>
      <div>
        <Button onClick={() => navigateTo(SUBSCRIPTIONS)}>{t('action.back-to-hotjar')}</Button>
      </div>
    </Stack>
  );
}
